import { render, staticRenderFns } from "./AppeaList.vue?vue&type=template&id=553cf023&scoped=true"
import script from "./AppeaList.vue?vue&type=script&lang=js"
export * from "./AppeaList.vue?vue&type=script&lang=js"
import style0 from "./AppeaList.vue?vue&type=style&index=0&id=553cf023&prod&lang=less"
import style1 from "./AppeaList.vue?vue&type=style&index=1&id=553cf023&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553cf023",
  null
  
)

export default component.exports